import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, UrlSerializer } from '@angular/router';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam, IResultReport } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-result-category',
  templateUrl: './exam-result-category.component.html',
  styleUrls: ['./exam-result-category.component.scss']
})
export class ExamResultCategoryComponent implements OnInit {
  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  dateOfWriting = '';
  skipImportCandidateData = false;
  excludeTestCandidates = true;
  constructor(private popoverRef: PopoverRef<ExamResultCategoryComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }

  async getResultReport() {

    let examId = this.exam.id;
    const reportTree = this.router.createUrlTree([], {
      queryParams: {
        "ExaminationID": examId,
        "dateOfWriting": this.dateOfWriting,
        "skipImportCandidateData": this.skipImportCandidateData,
        "excludeTestCandidates": this.excludeTestCandidates
      }
    });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];
    await this.examService.getExamResultCategoryReport(params).then((s: any) => {
      this.snackBar.success('Report Successfull');
      this.exportedFile = s;
    }).catch((e) => {
      console.log(e);
    });

  }
}
